var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Logo from '../../../../images/Notification.svg';
var StyledLink = styled(Link)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: black;\n    display: flex;\n    align-items: center;\n    text-decoration: unset;\n"], ["\n    color: black;\n    display: flex;\n    align-items: center;\n    text-decoration: unset;\n"])));
var Brand = function () {
    return _jsx(StyledLink, __assign({ to: "/" }, { children: _jsx(Logo, { preserveAspectRatio: "xMinYMid meet", viewBox: "0 -5 65 65" }) }));
};
export default Brand;
var templateObject_1;
